import React, { useState } from "react";
import "./navbarms.css";
import { Link } from 'react-router-dom';

const NavbarMs = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [aboutusMenuOpen, setAboutusMenuOpen] = useState(false);
  const [admissionsMenuOpen, setAdmissionsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const toggleAboutusMenu = () => {
    setAboutusMenuOpen(!aboutusMenuOpen);
    setAdmissionsMenuOpen(false);
  };

  const toggleAdmissionsMenu = () => {
    setAdmissionsMenuOpen(!admissionsMenuOpen);
    setAboutusMenuOpen(false);
  };

  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to the top
};

/*
 <Link
                        to = "/sports"
                        onClick={handleClick}
                        state = {{
                            data: { sporttype: "all", sportsection: "gallery", sportcate: "latest" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Sports</p></li>
                    </Link>

  <Link
                          to = "/clubs"
                          onClick={handleClick}
                          state = {{
                            data: { club: "all" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                          }}
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                        >
                        <p>Clubs</p>
                        </Link>


*/


  return (
    <>  
      
      <div className="navsectionmHs">
        <div className="schoollogonameHs">
            <img src="https://optimize.sirv.com/inforinnvo/innovlogo2.jpg"  alt="inforinnov" />
        </div>
        <img className="masiyefullnameHs" src="https://optimize.sirv.com/inforinnvo/innovlogo2.jpg" alt="inforinnov" />
        <nav className="navbarmainHs">
            <div className="navbar-containerHs">
                
                <ul className={`navlist ${showMenu ? 'show-menuHs' : ''}`}>
                    <div className={`close-iconHs ${showMenu ? 'show-iconHs' : ''}`} onClick={toggleMenu}>
                        &times;
                    </div>
                    <Link
                        to = "/"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li>
                      <p>Home</p>
                    </li>
                    </Link>
                    <Link
                        to = "/about-us"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>About Us</p></li>
                    </Link>

                    <Link
                        to = "/registration"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                      <li><p>Registration</p></li>
                    </Link>


                    <Link
                        to = "/studentlibrarylogin"
                        onClick={handleClick}
                        state = {{
                          data: { pagename: 'studentlibrarylogin' }  //register your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Login</p></li>
                    </Link>
                    <Link
                        to = "/contact-us"
                        onClick={handleClick}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Contact Us</p></li>
                    </Link>
                    <Link
                        to = "/portals"
                        onClick={handleClick}
                        state = {{
                          data: {portalname: "Library", pagename: 'portals' }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Portals</p></li>
                    </Link>
                    
                </ul>
                <div className={`menu-iconHs ${showMenu ? 'hide-iconHs' : ''}`} onClick={toggleMenu}>
                &#9776;
                </div>
            </div>
        </nav>
      </div>
    </>
  );
};

export default NavbarMs;



/*---------------------------------------------------------------------
 <Link
                        to = "/parents-space"
                        onClick={handleClick}
                        state = {{
                          data: { pagename: 'parent-space' }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Parent Space</p></li>
                    </Link>


  <Link
                        to = "/pta"
                        onClick={handleClick}
                        state = {{
                            data: { clothestype: "all" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>PTA</p></li>
                    </Link>

   <Link
                        to = "/studentportal"
                        onClick={handleClick}
                        state = {{
                          data: { pagename: 'studentportal' }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Student Portal</p></li>
                    </Link>



                    <li className="dropdownms" onClick={toggleAboutusMenu}>
                        <p>About &#9662;</p>
                        {aboutusMenuOpen &&
                        <div className="dropdownms-content">
                            <Link
                              to = "/about-us"
                              onClick={handleClick}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>About Oakcrest</p>
                            </Link>
                            <Link
                              to = "/gallery"
                              onClick={handleClick}
                              state = {{
                                  data: { gallery: "all" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                              }}
                              style={{ textDecoration: 'none', color: 'black', padding: 0}}
                            >
                            <p>Gallery</p>
                            </Link>
                           
                        </div>
                        }
                    </li>

                    <li className="dropdownms" onClick={toggleAdmissionsMenu}>
                        <p>Academics &#9662;</p>
                        {admissionsMenuOpen &&
                        <div className="dropdownms-content">
                        <Link
                          to = "/academics"
                          onClick={handleClick}
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                        >
                        <p>Curriculum</p>
                        </Link>
                        
                        
                        </div>
                        }
                    </li>


                     <Link
                        to = "/portals"
                        onClick={handleClick}
                        state = {{
                          data: {portalname: "Admin", pagename: 'portals' }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                        }}
                        style={{ textDecoration: 'none', color: 'black', padding: 0}}
                    >
                    <li><p>Portals</p></li>
                    </Link>


*/